// import React, { useState, useRef, useEffect } from "react";
// import * as XLSX from "xlsx";
// import Cookies from "js-cookie";
// import "./LenderUserUpload.css";
// import InformationModal from "../components/InformationModal";
// import { BiError } from "react-icons/bi";
// import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS

// const LenderUserDataUpload = () => {
//   const [singleUser, setSingleUser] = useState({
//     preapprovdlimitvalue: "",
//     contactAddress: "",
//     primaryPhone: "",
//     email: "",
//     name: "",
//     eventId: null,
//   });

//   const [excelData, setExcelData] = useState([]);
//   const [excelFile, setExcelFile] = useState(null);
//   const [activeForm, setActiveForm] = useState("single");
//   const [sortConfig, setSortConfig] = useState({
//     key: null,
//     direction: "ascending",
//   });
//   const [duplicates, setDuplicates] = useState([]);
//   const [showDuplicatesModal, setShowDuplicatesModal] = useState(false);
//   const fileInputRef = useRef(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [ModalMessage, setModalMessage] = useState('');

//   const openInfoModal = () => setIsModalOpen(true);
//   const closeInfoModal = () => setIsModalOpen(false);

//   useEffect(() => {
//     const communityNo = Cookies.get("adminCommunityNO");
//     if (communityNo) {
//       setSingleUser((prevUser) => ({
//         ...prevUser,
//         communityNo,
//       }));
//     }
//   }, []);

//   const generateBatchNo = (isMultiUser = false) => {
//     const communityNo = Cookies.get("adminCommunityNO");
//     const currentTime = new Date().getTime();
//     return `${communityNo}_${currentTime}${isMultiUser ? "" : "_1"}`;
//   };

//   const checkDuplicate = async (e) => {
//     e.preventDefault()
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_ENDPOINT}/api/lender/users/isDuplicate?phoneNumber=${encodeURIComponent(singleUser.primaryPhone)}&email=${encodeURIComponent(singleUser.email)}`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             "X-Full-URL": window.location.href, // Optional: full URL

//           },
//           credentials: "include",
//         }
//       );

//       if (!response.ok) {
//         throw new Error(`Server error: ${response.status}`);
//       }

//       const result = await response.json(); // assuming the server returns plain text, like "Duplicate found..." or null

//       if (result) {
//         setDuplicates([result]);
//         setShowDuplicatesModal(true);
//       } else {
//         console.log("No duplicate found.");
//       }
//     } catch (error) {
//       console.error("Error checking duplicate:", error.message);
//     }
//   };

//   const modalStyles = {
//     modal: {
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//       position: "fixed",
//       top: 0,
//       left: 0,
//       width: "100%",
//       height: "100%",
//       backgroundColor: "rgba(0, 0, 0, 0.5)",
//       borderRadius:"20px",
//       zIndex: 1000,
//     },
//     modalHeader: {
//       backgroundColor: "#ee373b",
//       color: "white",
//       padding: "10px !important",
//       borderTopLeftRadius: "20px",
//       borderTopRightRadius: "20px",
//       display: "flex",
//       justifyContent: "flex-start",
//       alignItems: "center",
//     },
//     headerText: {
//       margin: 0,
//       marginLeft: "10px",
//       fontSize:"18px",
//       fontWeight: "bold",
//       color: "white"
//     },
//     closeBtn: {
//       cursor: "pointer",
//       fontSize: "24px",
//     },
//     customModelBody: {
//       maxHeight: "50vh",
//       overflowY: "auto",
//       scrollbarWidth: "thin",
//       scrollbarColor: "#ee373b #f1f1f1"
//     },
//     table: {
//       width: "100%",
//       borderCollapse: "collapse",
//     },
//     th: {
//       border: "none !important",
//       padding: "8px",
//       textAlign: "left",
//       backgroundColor: "#f2f2f2",
//     },
//     td: {
//       border: "1.5px solid #ee373b",
//       padding: "8px",
//       textAlign: "left"
//     },
//   };

//   const handleSingleUserChange = (e) => {
//     const { name, value } = e.target;
//     setSingleUser((prevUser) => ({
//       ...prevUser,
//       [name]: value,
//     }));
//   };

//   const isValidEmail = (email) => {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return emailRegex.test(email);
//   };

//   const isValidPhoneNumber = (phone) => {
//     const phoneRegex = /^\d{10}$/;
//     return phoneRegex.test(phone);
//   };

//   const isValidName = (name) => {
//     const nameRegex = /^[a-zA-Z\s]+$/;
//     return nameRegex.test(name);
//   };

//   const isSingleUserFormValid = () => {
//     const { preapprovdlimitvalue, contactAddress, primaryPhone, email, name } =
//       singleUser;
//     return (
//       preapprovdlimitvalue &&
//       contactAddress &&
//       isValidPhoneNumber(primaryPhone) &&
//       isValidEmail(email) &&
//       isValidName(name)
//     );
//   };

//   const handleSingleUserSubmit = async (e) => {
//     e.preventDefault();
//     if (!isSingleUserFormValid()) return;

//     const batchNo = generateBatchNo(false);
//     const uploadFileName = "single user upload";
//     const createdDateAndTime = new Date().toISOString().replace("Z", "");
//     const communityNo = parseInt(Cookies.get("adminCommunityNO"), 10);

//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_ENDPOINT}/api/lender/users/singleUpload?communityNo=${communityNo}&batchNo=${batchNo}&uploadFileName=${uploadFileName}&createdDateAndTime=${createdDateAndTime}`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             "X-Full-URL": window.location.href, // Optional: full URL
//           },
//           body: JSON.stringify({
//             ...singleUser,
//             preapprovdlimitvalue: parseInt(singleUser.preapprovdlimitvalue),
//             eventId: null,
//           }),
//           credentials: "include",
//         }
//       );

//       const text = await response.text();
//       let result = null;

//       if (text) {
//         try {
//           result = JSON.parse(text);
//         } catch (error) {
//           console.error("Failed to parse JSON:", error);
//         }
//       }

//       if (response.ok) {
//         if (result) {
//           setDuplicates([result]);
//           setShowDuplicatesModal(true); // Show duplicate modal
//         }
//         if(result==null || result==undefined){
//           setModalMessage("Customer succefully added.");
//           setIsModalOpen(true);
//         }
//         // alert("🎉 Single user uploaded successfully!");
//         setSingleUser({
//           preapprovdlimitvalue: "",
//           contactAddress: "",
//           primaryPhone: "",
//           email: "",
//           name: "",
//           eventId: null,
//         });
//       } else {
//         throw new Error("Failed to upload single user.");
//       }
//     } catch (error) {
//       console.error("Error uploading single user:", error);
//       // alert("❌ Failed to upload single user.");
//     }
//   };

//   const handleExcelFileChange = (e) => {
//     const file = e.target.files[0];
//     setExcelFile(file);
//     const reader = new FileReader();
//     reader.onload = (event) => {
//       const binaryStr = event.target.result;
//       const workbook = XLSX.read(binaryStr, { type: "binary" });
//       const firstSheetName = workbook.SheetNames[0];
//       const worksheet = workbook.Sheets[firstSheetName];
//       const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
//       setExcelData(data);
//     };
//     reader.readAsBinaryString(file);
//   };

//   const handleMultiUserSubmit = async (e) => {
//     e.preventDefault();
//     if (!excelFile) {
//       alert("📂 Please upload an Excel file first.");
//       return;
//     }

//     const batchNo = generateBatchNo(true);
//     const createdDateAndTime = new Date().toISOString().replace("Z", "");
//     const communityNo = parseInt(Cookies.get("adminCommunityNO"), 10);
//     const formData = new FormData();
//     formData.append("file", excelFile);
//     formData.append("communityNumber", communityNo);

//     try {
//       const excelResponse = await fetch(
//         `${process.env.REACT_APP_API_ENDPOINT}/api/lender/users/excel`,
//         {
//           method: "POST",
//           body: formData,
//           credentials: "include",
//           headers: {
//             "X-Full-URL": window.location.href,
//           }
//         }
//       );

//       if (!excelResponse.ok) {
//         throw new Error("Failed to upload Excel file.");
//       }

//       // Filter out rows with any null or empty fields
//       // const filteredExcelData = excelData.slice(1).filter(row =>
//       //   row.every(field =>  )
//       // );

//       const filteredExcelData = excelData.slice(1).filter((row, idx) => {
//         const isValid = row.every(field => {
//         // Exclude if field is undefined or only whitespace when converted to string
//         if (typeof field === 'undefined' || field !== null || field !== "") return false;
//         const trimmed = field.toString().trim();
//         return trimmed !== '';
//         });
//         if (!isValid) {
//           console.log(`Filtered out row at index ${idx + 1}:`, row);
//         }
//         return isValid;
//       });

//       const buyers = filteredExcelData.map((row) => ({
//         preapprovdlimitvalue: parseInt(row[4]),
//         contactAddress: row[1],
//         primaryPhone: row[2],
//         email: row[3],
//         name: row[0],
//         eventId: null,
//       }));

//       const multiUploadResponse = await fetch(
//         `${process.env.REACT_APP_API_ENDPOINT}/api/lender/users/multiUpload?communityNo=${communityNo}&batchNo=${batchNo}&uploadFileName=${excelFile.name}&createdDateAndTime=${createdDateAndTime}`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             "X-Full-URL": window.location.href,
//           },
//           body: JSON.stringify(buyers),
//           credentials: "include",
//         }
//       );

//       const result = await multiUploadResponse.json();
//       if (multiUploadResponse.ok) {
//         if (result.length > 0) {
//           setDuplicates(result);
//           setShowDuplicatesModal(true);
//           setModalMessage("Multiple Customers uploaded successfully - Duplicate Entries are ignored.");
//           setIsModalOpen(true);
//         }
//         else{
//           setModalMessage("Multiple Customers successfully added");
//           setIsModalOpen(true);
//         }
//         setExcelData([]);
//         setExcelFile(null);
//         if (fileInputRef.current) {
//           fileInputRef.current.value = "";
//         }
//       } else {
//         throw new Error("Failed to upload multi-user data.");
//       }
//     } catch (error) {
//       console.error("Error uploading multi-user data:", error);
//       alert("❌ Failed to upload multi-user data.");
//     }
//   };


//   const requestSort = (index) => {
//     let direction = "ascending";
//     if (sortConfig.key === index && sortConfig.direction === "ascending") {
//       direction = "descending";
//     }
//     setSortConfig({ key: index, direction });
//   };

//   const getFilteredSortedData = () => {
//     let filteredData = excelData.slice(1);

//     if (sortConfig.key !== null) {
//       filteredData.sort((a, b) => {
//         if (a[sortConfig.key] < b[sortConfig.key]) {
//           return sortConfig.direction === "ascending" ? -1 : 1;
//         }
//         if (a[sortConfig.key] > b[sortConfig.key]) {
//           return sortConfig.direction === "ascending" ? 1 : -1;
//         }
//         return 0;
//       });
//     }

//     return filteredData;
//   };

//   const closeDuplicatesModal = () => {
//     setShowDuplicatesModal(false);
//     setDuplicates([]);
//   };

//   return (
//     <div id="lender-upload-container" className="p-0">
//       <style>
//         {`
//         .modal-content{
//           border-radius: 20px;
//         }
//         `}
//       </style>

//       <div style={{ margin: "0x -26px" }}>
//         <h2
//           className="header_txt"
//           style={{ borderTopLeftRadius: "18px", borderTopRightRadius: "18px" }}
//         >
//           Customer Upload
//         </h2>
//       </div>

//       <div id="form-toggle" className="mt-4 justify-content-center">
//         <label className="radio-label">
//           <input
//             type="radio"
//             name="formType"
//             value="single"
//             checked={activeForm === "single"}
//             onChange={() => setActiveForm("single")}
//           />
//           <span className="form_header">Individual</span>
//         </label>
//         <label className="radio-label">
//           <input
//             type="radio"
//             name="formType"
//             value="multi"
//             checked={activeForm === "multi"}
//             onChange={() => setActiveForm("multi")}
//           />
//           <span className="form_header">Bulk</span>
//         </label>
//       </div>

//       {activeForm === "single" && (
//         <form id="single-user-form" onSubmit={handleSingleUserSubmit}>
//           <div id="input-grid" className="p-4">
//             <div className="row formrow">
//               <div className="form-field col-6">
//                 <div className="row formrow mt-3" style={{ display: "ruby" }}>
//                   <div className="col-7">
//                     <label htmlFor="preapprovdlimitvalue">
//                       Preapproved Loan Value
//                     </label>
//                   </div>
//                   <div className="col-5">
//                     <div className="dropdown_my">
//                       <input
//                         type="checkbox"
//                         className="dropdown__switch"
//                         id="filter-switch"
//                         hidden
//                       />
//                       <label
//                         htmlFor="filter-switch"
//                         className="dropdown__options-filter"
//                       >
//                         <ul
//                           className="dropdown__filter"
//                           role="listbox"
//                           tabIndex="-1"
//                         >
//                           <li
//                             className="dropdown__filter-selected"
//                             aria-selected="true"
//                           >
//                             {singleUser.preapprovdlimitvalue || "Choose"}
//                             <li>
//                               <ul className="dropdown__select">
//                                 <li
//                                   className="dropdown__select-option"
//                                   role="option"
//                                   onClick={() =>
//                                     handleSingleUserChange({
//                                       target: {
//                                         name: "preapprovdlimitvalue",
//                                         value: "300000",
//                                       },
//                                     })
//                                   }
//                                 >
//                                   3,00,000
//                                 </li>
//                                 <li
//                                   className="dropdown__select-option"
//                                   role="option"
//                                   onClick={() =>
//                                     handleSingleUserChange({
//                                       target: {
//                                         name: "preapprovdlimitvalue",
//                                         value: "500000",
//                                       },
//                                     })
//                                   }
//                                 >
//                                   5,00,000
//                                 </li>
//                                 <li
//                                   className="dropdown__select-option"
//                                   role="option"
//                                   onClick={() =>
//                                     handleSingleUserChange({
//                                       target: {
//                                         name: "preapprovdlimitvalue",
//                                         value: "700000",
//                                       },
//                                     })
//                                   }
//                                 >
//                                   7,00,000
//                                 </li>
//                                 <li
//                                   className="dropdown__select-option"
//                                   role="option"
//                                   onClick={() =>
//                                     handleSingleUserChange({
//                                       target: {
//                                         name: "preapprovdlimitvalue",
//                                         value: "1000000",
//                                       },
//                                     })
//                                   }
//                                 >
//                                   10,00,000
//                                 </li>
//                               </ul>
//                             </li>
//                           </li>
//                         </ul>
//                       </label>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className="form-field col-6">
//                 <div className="row formrow">
//                   <div className="col-4">
//                     <label htmlFor="name">Name</label>
//                   </div>
//                   <div className="col-8">
//                     <input
//                       type="text"
//                       id="name"
//                       name="name"
//                       value={singleUser.name}
//                       onChange={handleSingleUserChange}
//                       required
//                       placeholder="Enter name"
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="row  formrow">
//               <div className="form-field col-6">
//                 <div className="row formrow">
//                   <div className="col-2">
//                     <label htmlFor="email">Email</label>
//                   </div>
//                   <div className="col-10">
//                     <input
//                       type="email"
//                       id="email"
//                       name="email"
//                       value={singleUser.email}
//                       onChange={handleSingleUserChange}
//                       required
//                       placeholder="Enter email (e.g., example@example.com)"
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div className="form-field col-6">
//                 <div className="row formrow">
//                   <div className="col-4">
//                     <label htmlFor="primaryPhone">Phone Number</label>
//                   </div>
//                   <div className="col-8">
//                     <input
//                       type="tel"
//                       id="primaryPhone"
//                       name="primaryPhone"
//                       value={singleUser.primaryPhone}
//                       onChange={handleSingleUserChange}
//                       required
//                       placeholder="Enter mobile number"
//                       pattern="[0-9]{10}" // Ensures only numeric input
//                       title="Please enter a valid 10-digit mobile number"
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="row formrow">
//               <div className="form-field col-12">
//                 <div className="row formrow">
//                   <div className="col-1">
//                     <label htmlFor="contactAddress">Address</label>
//                   </div>
//                   <div className="col-11">
//                     <input
//                       id="contactAddress"
//                       name="contactAddress"
//                       value={singleUser.contactAddress}
//                       onFocus={checkDuplicate}
//                       onChange={handleSingleUserChange}
//                       required
//                       style={{
//                         width: "100%",
//                         padding: "0.6rem",
//                         backgroundColor: "white",
//                         border: "1px solid #ee373b",
//                         borderRadius: "6px",
//                         fontSize: "1rem",
//                         transition: "all 0.3s ease",
//                         color: singleUser.contactAddress ? "black" : "gray",
//                       }}
//                       placeholder="Enter address"
//                     />
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="d-flex justify-content-center">
//               <button
//                 type="submit"
//                 className="btn btn-outline-danger"
//                 style={{ width: "150px", height: "40px" }}
//                 disabled={!isSingleUserFormValid()}
//               >
//                 <center>
//                   <span>Submit</span>
//                 </center>
//               </button>
//             </div>
//           </div>
//         </form>
//       )}

//       {activeForm === "multi" && (
//         <form id="multi-user-form" onSubmit={handleMultiUserSubmit}>
//           <div id="file-upload-container">
//             <input
//               ref={fileInputRef}
//               type="file"
//               accept=".xlsx"
//               onChange={handleExcelFileChange}
//               required
//             />
//             <div id="file-upload-placeholder">
//               {excelFile
//                 ? `📄 ${excelFile.name}`
//                 : "📂 Click to select Excel file"}
//             </div>
//           </div>

//           {excelData.length > 1 && ( // Ensure there is data beyond the header row
//             <div
//               id="table-container"
//               style={{
//                 maxHeight: "35vh",
//                 overflowY: "auto",
//                 scrollbarWidth: "none",
//                 scrollbarColor: "#ee373b #fefefe",
//               }}
//             >
//               <div id="excel-data-table-wrapper" style={{ maxHeight: "35vh" }}>
//                 <table id="excel-data-table">
//                   <table id="excel-data-table">
//                     <thead>
//                       <tr>
//                         {excelData[0].slice(0, 5).map((header, index) => (
//                           <th
//                             key={index}
//                             onClick={() => requestSort(index)}
//                             style={modalStyles.th}
//                           >
//                             {header}{" "}
//                             {sortConfig.key === index &&
//                               (sortConfig.direction === "ascending"
//                                 ? "↑"
//                                 : "↓")}
//                           </th>
//                         ))}
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {excelData.slice(1).map((row, rowIndex) => {
//                         console.log(
//                           `${row.slice(0, 5).map((cell) => (
//                             cell
//                           ))} , ${typeof(cell)}, `
//                         )
//                         return (
//                         <tr key={rowIndex}>
//                           {row.slice(0, 5).map((cell, cellIndex) => (
//                             <td key={cellIndex}>{cell}</td>
//                           ))}
//                         </tr>
//                       )})}
//                     </tbody>
//                   </table>
//                 </table>
//               </div>
//               <div className="d-flex flex-column justify-content-center px-0">
//                 <div
//                   style={{
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "center",
//                     padding: "5px",
//                     borderTop: "2px solid #ee373b",
//                   }}
//                 >
//                   <button
//                     type="submit"
//                     className="btn btn-outline-danger"
//                     style={{
//                       width: "150px",
//                       height: "40px",
//                     }}
//                     disabled={!excelFile}
//                   >
//                     <span className="">Submit</span>
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}
//         </form>
//       )}

//       {showDuplicatesModal && (
//         <div id="duplicates-modal" style={modalStyles.modal}>
//           <div
//             className="modal-content"
//             id="modal-content-radius"
//             style={{
//               padding: "0px",
//               width: "80%",
//               maxWidth: "600px",
//               borderRadius: "20px",
//             }}
//           >
//             <div className="modal-header" style={modalStyles.modalHeader}>
//                <span><BiError size="30" /></span> <p style={modalStyles.headerText}> Duplicate Entries</p>
//             </div>
//             <div className="p-2" style={modalStyles.customModelBody}>
//               <table style={modalStyles.table}>
//                 <thead style={{ position: "sticky", top: "0" }}>
//                   <tr>
//                     <th style={modalStyles.th}>Name</th>
//                     <th style={modalStyles.th}>Primary Phone</th>
//                     <th style={modalStyles.th}>Email</th>
//                     <th style={modalStyles.th}>Contact Address</th>
//                     <th style={modalStyles.th}>Preapproved Limit</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {duplicates.map((duplicate, index) => (
//                     <tr key={index}>
//                       <td style={modalStyles.td}>{duplicate.name}</td>
//                       <td style={modalStyles.td}>{duplicate.primaryPhone}</td>
//                       <td style={modalStyles.td}>{duplicate.email}</td>
//                       <td style={modalStyles.td}>{duplicate.contactAddress}</td>
//                       <td style={modalStyles.td}>
//                         {duplicate.preapprovdlimitvalue}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//             <div
//               className="p-2 d-flex justify-content-center"
//               style={{
//                 borderBottomLeftRadius: "20px",
//                 borderBottomRightRadius: "20px",
//               }}
//             >
//               <button
//                 className="btn btn-outline-danger"
//                 onClick={closeDuplicatesModal}
//               >
//                 close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       <InformationModal
//         isOpen={isModalOpen}
//         onClose={closeInfoModal}
//         message={ModalMessage}
//       />
//     </div>
//   );
// };

// export default LenderUserDataUpload;



import React, { useState, useRef, useEffect } from "react";
import * as XLSX from "xlsx";
import Cookies from "js-cookie";
import "./LenderUserUpload.css";
import InformationModal from "../components/InformationModal";
import { BiError } from "react-icons/bi";
import "bootstrap/dist/css/bootstrap.min.css";

const LenderUserDataUpload = () => {
  const [singleUser, setSingleUser] = useState({
    preapprovdlimitvalue: "",
    contactAddress: "",
    primaryPhone: "",
    email: "",
    name: "",
    eventId: null,
  });

  const [validationErrors, setValidationErrors] = useState({
    preapprovdlimitvalue: "",
    contactAddress: "",
    primaryPhone: "",
    email: "",
    name: "",
  });

  const [excelData, setExcelData] = useState([]);
  const [excelFile, setExcelFile] = useState(null);
  const [activeForm, setActiveForm] = useState("single");
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const [duplicates, setDuplicates] = useState([]);
  const [showDuplicatesModal, setShowDuplicatesModal] = useState(false);
  const fileInputRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ModalMessage, setModalMessage] = useState('');

  const openInfoModal = () => setIsModalOpen(true);
  const closeInfoModal = () => setIsModalOpen(false);

  useEffect(() => {
    const communityNo = Cookies.get("adminCommunityNO");
    if (communityNo) {
      setSingleUser((prevUser) => ({
        ...prevUser,
        communityNo,
      }));
    }
  }, []);

  const generateBatchNo = (isMultiUser = false) => {
    const communityNo = Cookies.get("adminCommunityNO");
    const currentTime = new Date().getTime();
    return `${communityNo}_${currentTime}${isMultiUser ? "" : "_1"}`;
  };

  const checkDuplicate = async (e) => {
    e.preventDefault()
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/lender/users/isDuplicate?phoneNumber=${encodeURIComponent(singleUser.primaryPhone)}&email=${encodeURIComponent(singleUser.email)}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "X-Full-URL": window.location.href,
          },
          credentials: "include",
        }
      );

      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }

      const result = await response.json();

      if (result) {
        setDuplicates([result]);
        setShowDuplicatesModal(true);
      } else {
        console.log("No duplicate found.");
      }
    } catch (error) {
      console.error("Error checking duplicate:", error.message);
    }
  };

  const modalStyles = {
    modal: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      borderRadius: "20px",
      zIndex: 1000,
    },
    modalHeader: {
      backgroundColor: "#ee373b",
      color: "white",
      padding: "10px !important",
      borderTopLeftRadius: "20px",
      borderTopRightRadius: "20px",
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
    },
    headerText: {
      margin: 0,
      marginLeft: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "white"
    },
    closeBtn: {
      cursor: "pointer",
      fontSize: "24px",
    },
    customModelBody: {
      maxHeight: "50vh",
      overflowY: "auto",
      scrollbarWidth: "thin",
      scrollbarColor: "#ee373b #f1f1f1"
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
    },
    th: {
      border: "none !important",
      padding: "8px",
      textAlign: "left",
      backgroundColor: "#f2f2f2",
    },
    td: {
      border: "1.5px solid #ee373b",
      padding: "8px",
      textAlign: "left"
    },
  };

  const validateField = (name, value) => {
    switch (name) {
      case "preapprovdlimitvalue":
        if (!value) return "Select Preapproved Loan";
        break;
      case "contactAddress":
        if (!value) return "Contact Address is required";
        break;
      case "primaryPhone":
        if (!value) return "Phone Number is required";
        if (!isValidPhoneNumber(value)) return "Please enter a valid 10-digit phone number";
        break;
      case "email":
        if (!value) return "Email is required";
        if (!isValidEmail(value)) return "Please enter a valid email address";
        break;
      case "name":
        if (!value) return "Name is required";
        if (!isValidName(value)) return "Name can only contain letters and spaces";
        break;
      default:
        break;
    }
    return "";
  };

  const validateForm = () => {
    const newErrors = {
      preapprovdlimitvalue: validateField("preapprovdlimitvalue", singleUser.preapprovdlimitvalue),
      contactAddress: validateField("contactAddress", singleUser.contactAddress),
      primaryPhone: validateField("primaryPhone", singleUser.primaryPhone),
      email: validateField("email", singleUser.email),
      name: validateField("name", singleUser.name),
    };
    setValidationErrors(newErrors);
    return Object.values(newErrors).every(error => !error);
  };

  useEffect(() => {
    validateForm();
  }, [singleUser]);

  const handleSingleUserChange = (e) => {
    const { name, value } = e.target;
    setSingleUser((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
    const error = validateField(name, value);
    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9]+([._+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const isValidPhoneNumber = (phone) => {
    const phoneRegex = /^\d{10}$/;
    return phoneRegex.test(phone);
  };

  const isValidName = (name) => {
    const nameRegex = /^[a-zA-Z\s]+$/;
    return nameRegex.test(name);
  };

  const isSingleUserFormValid = () => {
    return Object.values(validationErrors).every(error => !error);
  };

  const handleSingleUserSubmit = async (e) => {
    e.preventDefault();
    const isValid = validateForm();
    if (isValid) {
      const batchNo = generateBatchNo(false);
      const uploadFileName = "single user upload";
      const createdDateAndTime = new Date().toISOString().replace("Z", "");
      const communityNo = parseInt(Cookies.get("adminCommunityNO"), 10);

      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_ENDPOINT}/api/lender/users/singleUpload?communityNo=${communityNo}&batchNo=${batchNo}&uploadFileName=${uploadFileName}&createdDateAndTime=${createdDateAndTime}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Full-URL": window.location.href,
            },
            body: JSON.stringify({
              ...singleUser,
              preapprovdlimitvalue: parseInt(singleUser.preapprovdlimitvalue),
              eventId: null,
            }),
            credentials: "include",
          }
        );

        const text = await response.text();
        let result = null;

        if (text) {
          try {
            result = JSON.parse(text);
          } catch (error) {
            console.error("Failed to parse JSON:", error);
          }
        }

        if (response.ok) {
          if (result) {
            setDuplicates([result]);
            setShowDuplicatesModal(true);
          }
          if (result == null || result == undefined) {
            setModalMessage("Customer successfully added.");
            setIsModalOpen(true);
          }
          setSingleUser({
            preapprovdlimitvalue: "",
            contactAddress: "",
            primaryPhone: "",
            email: "",
            name: "",
            eventId: null,
          });
        } else {
          throw new Error("Failed to upload single user.");
        }
      } catch (error) {
        console.error("Error uploading single user:", error);
      }
    }
  };

  const handleExcelFileChange = (e) => {
    const file = e.target.files[0];
    setExcelFile(file);
    const reader = new FileReader();
    reader.onload = (event) => {
      const binaryStr = event.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const data = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      setExcelData(data);
    };
    reader.readAsBinaryString(file);
  };

  const handleMultiUserSubmit = async (e) => {
    e.preventDefault();
    if (!excelFile) {
      alert("Please upload an Excel file first.");
      return;
    }

    const batchNo = generateBatchNo(true);
    const createdDateAndTime = new Date().toISOString().replace("Z", "");
    const communityNo = parseInt(Cookies.get("adminCommunityNO"), 10);
    const formData = new FormData();
    formData.append("file", excelFile);
    formData.append("communityNumber", communityNo);

    try {
      const excelResponse = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/lender/users/excel`,
        {
          method: "POST",
          body: formData,
          credentials: "include",
          headers: {
            "X-Full-URL": window.location.href,
          }
        }
      );

      if (!excelResponse.ok) {
        throw new Error("Failed to upload Excel file.");
      }

      const filteredExcelData = excelData.slice(1).filter((row, idx) => {
        const isValid = row.every(field => {
          if (typeof field === 'undefined' || field === null || field === "" || field == NaN) return false;
          const trimmed = field.toString().trim();
          return trimmed !== '';
        });
        if (!isValid) {
          console.log(`Filtered out row at index ${idx + 1}:`, row);
        }
        return isValid;
      });

      const buyers = filteredExcelData.filter(row => row.length > 0).map((row) => ({
        preapprovdlimitvalue: parseInt(row[4]),
        contactAddress: row[1],
        primaryPhone: row[2],
        email: row[3],
        name: row[0],
        eventId: null,
      }));

      console.log(filteredExcelData);

      const multiUploadResponse = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/lender/users/multiUpload?communityNo=${communityNo}&batchNo=${batchNo}&uploadFileName=${excelFile.name}&createdDateAndTime=${createdDateAndTime}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Full-URL": window.location.href,
          },
          body: JSON.stringify(buyers),
          credentials: "include",
        }
      );
      console.log(buyers);

      const result = await multiUploadResponse.json();
      if (multiUploadResponse.ok) {
        if (result.length > 0) {
          setDuplicates(result);
          setShowDuplicatesModal(true);
          setModalMessage("Multiple Customers uploaded successfully - Duplicate Entries are ignored.");
          setIsModalOpen(true);
        }
        else {
          setModalMessage("Multiple Customers successfully added");
          setIsModalOpen(true);
        }
        setExcelData([]);
        setExcelFile(null);
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } else {
        throw new Error("Failed to upload multi-user data.");
      }
    } catch (error) {
      console.error("Error uploading multi-user data:", error);
      alert("Failed to upload multi-user data.");
    }
  };

  const requestSort = (index) => {
    let direction = "ascending";
    if (sortConfig.key === index && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key: index, direction });
  };

  const getFilteredSortedData = () => {
    let filteredData = excelData.slice(1);

    if (sortConfig.key !== null) {
      filteredData.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return filteredData;
  };

  const closeDuplicatesModal = () => {
    setShowDuplicatesModal(false);
    setDuplicates([]);
  };

  return (
    <div id="lender-upload-container" className="p-0">
      <style>
        {`
          .modal-content{
            border-radius: 20px;
          }
        `}
      </style>

      <div style={{ margin: "0x -26px" }}>
        <h2
          className="header_txt"
          style={{ borderTopLeftRadius: "18px", borderTopRightRadius: "18px" }}
        >
          Customer Upload
        </h2>
      </div>

      <div id="form-toggle" className="mt-4 justify-content-center">
        <label className="radio-label">
          <input
            type="radio"
            name="formType"
            value="single"
            checked={activeForm === "single"}
            onChange={() => setActiveForm("single")}
          />
          <span className="form_header">Individual</span>
        </label>
        <label className="radio-label">
          <input
            type="radio"
            name="formType"
            value="multi"
            checked={activeForm === "multi"}
            onChange={() => setActiveForm("multi")}
          />
          <span className="form_header">Bulk</span>
        </label>
      </div>

      {activeForm === "single" && (
        <form id="single-user-form" onSubmit={handleSingleUserSubmit}>
          <div id="input-grid" className="p-4">
            <div className="row formrow">
              <div className="form-field col-6">
                <div className="row formrow mt-3">
                  <div className="col-7">
                    <label htmlFor="preapprovdlimitvalue">
                      Preapproved Loan Value
                    </label>
                  </div>
                  <div className="col-5 p-0">
                    <div className="dropdown_my mb-0">
                      <input
                        type="checkbox"
                        className="dropdown__switch"
                        id="filter-switch"
                        hidden
                      />
                      <label
                        htmlFor="filter-switch"
                        className="dropdown__options-filter mb-0"
                      >
                        <ul
                          className="dropdown__filter"
                          role="listbox"
                          tabIndex="-1"
                        >
                          <li
                            className="dropdown__filter-selected"
                            aria-selected="true"
                          >
                            {singleUser.preapprovdlimitvalue || "Choose"}
                            <li>
                              <ul className="dropdown__select">
                                <li
                                  className="dropdown__select-option"
                                  role="option"
                                  onClick={() =>
                                    handleSingleUserChange({
                                      target: {
                                        name: "preapprovdlimitvalue",
                                        value: "300000",
                                      },
                                    })
                                  }
                                >
                                  3,00,000
                                </li>
                                <li
                                  className="dropdown__select-option"
                                  role="option"
                                  onClick={() =>
                                    handleSingleUserChange({
                                      target: {
                                        name: "preapprovdlimitvalue",
                                        value: "500000",
                                      },
                                    })
                                  }
                                >
                                  5,00,000
                                </li>
                                <li
                                  className="dropdown__select-option"
                                  role="option"
                                  onClick={() =>
                                    handleSingleUserChange({
                                      target: {
                                        name: "preapprovdlimitvalue",
                                        value: "700000",
                                      },
                                    })
                                  }
                                >
                                  7,00,000
                                </li>
                                <li
                                  className="dropdown__select-option"
                                  role="option"
                                  onClick={() =>
                                    handleSingleUserChange({
                                      target: {
                                        name: "preapprovdlimitvalue",
                                        value: "1000000",
                                      },
                                    })
                                  }
                                >
                                  10,00,000
                                </li>
                              </ul>
                            </li>
                          </li>
                        </ul>
                      </label>
                    </div>
                    {validationErrors.preapprovdlimitvalue && (
                      <div style={{
                        color: "#ee373b",
                        fontSize: "12px",
                        marginTop: "5px",
                        display: "flex",
                        alignItems: "center"
                      }}>
                        <BiError style={{ marginRight: "5px" }} />
                        {validationErrors.preapprovdlimitvalue}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="form-field col-6">
                <div className="row formrow">
                  <div className="col-4">
                    <label htmlFor="name">Name</label>
                  </div>
                  <div className="col-8">
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={singleUser.name}
                      onChange={handleSingleUserChange}
                      required
                      placeholder="Enter name"
                    />
                    {validationErrors.name && (
                      <div style={{
                        color: "#ee373b",
                        fontSize: "12px",
                        marginTop: "5px",
                        display: "flex",
                        alignItems: "center"
                      }}>
                        <BiError style={{ marginRight: "5px" }} />
                        {validationErrors.name}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="row formrow">
              <div className="form-field col-6">
                <div className="row formrow">
                  <div className="col-2">
                    <label htmlFor="email">Email</label>
                  </div>
                  <div className="col-10">
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={singleUser.email}
                      onChange={handleSingleUserChange}
                      required
                      placeholder="Enter email (e.g., example@example.com)"
                    />
                    {validationErrors.email && (
                      <div style={{
                        color: "#ee373b",
                        fontSize: "12px",
                        marginTop: "5px",
                        display: "flex",
                        alignItems: "center"
                      }}>
                        <BiError style={{ marginRight: "5px" }} />
                        {validationErrors.email}
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="form-field col-6">
                <div className="row formrow">
                  <div className="col-4">
                    <label htmlFor="primaryPhone">Phone Number</label>
                  </div>
                  <div className="col-8">
                    <input
                      type="tel"
                      id="primaryPhone"
                      name="primaryPhone"
                      value={singleUser.primaryPhone}
                      onChange={handleSingleUserChange}
                      required
                      placeholder="Enter mobile number"
                      pattern="[0-9]{10}"
                      maxLength={10}
                      title="Please enter a valid 10-digit mobile number"
                    />
                    {validationErrors.primaryPhone && (
                      <div style={{
                        color: "#ee373b",
                        fontSize: "12px",
                        marginTop: "5px",
                        display: "flex",
                        alignItems: "center"
                      }}>
                        <BiError style={{ marginRight: "5px" }} />
                        {validationErrors.primaryPhone}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="row formrow">
              <div className="form-field col-12">
                <div className="row formrow">
                  <div className="col-1">
                    <label htmlFor="contactAddress">Address</label>
                  </div>
                  <div className="col-11">
                    <input
                      id="contactAddress"
                      name="contactAddress"
                      value={singleUser.contactAddress}
                      onFocus={checkDuplicate}
                      onChange={handleSingleUserChange}
                      required
                      style={{
                        width: "100%",
                        padding: "0.6rem",
                        backgroundColor: "white",
                        border: "1px solid #ee373b",
                        borderRadius: "6px",
                        fontSize: "1rem",
                        transition: "all 0.3s ease",
                        color: singleUser.contactAddress ? "black" : "gray",
                      }}
                      placeholder="Enter address"
                    />
                    {validationErrors.contactAddress && (
                      <div style={{
                        color: "#ee373b",
                        fontSize: "12px",
                        marginTop: "5px",
                        display: "flex",
                        alignItems: "center"
                      }}>
                        <BiError style={{ marginRight: "5px" }} />
                        {validationErrors.contactAddress}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center">
              <button
                type="submit"
                className="btn btn-outline-danger"
                style={{ width: "150px", height: "40px" }}
                disabled={!isSingleUserFormValid()}
              >
                <center>
                  <span>Submit</span>
                </center>
              </button>
            </div>
          </div>
        </form>
      )}

      {activeForm === "multi" && (
        <form id="multi-user-form" onSubmit={handleMultiUserSubmit}>
          <div id="file-upload-container">
            <input
              ref={fileInputRef}
              type="file"
              accept=".xlsx"
              onChange={handleExcelFileChange}
              required
            />
            <div id="file-upload-placeholder">
              {excelFile
                ? `📄 ${excelFile.name}`
                : "📂 Click to select Excel file"}
            </div>
          </div>

          {excelData.length > 1 && (
            <div
              id="table-container"
              style={{
                maxHeight: "35vh",
                overflowY: "auto",
                scrollbarWidth: "none",
                scrollbarColor: "#ee373b #fefefe",
              }}
            >
              <div id="excel-data-table-wrapper" style={{ maxHeight: "35vh" }}>
                <table id="excel-data-table">
                  <thead>
                    <tr>
                      {excelData[0].slice(0, 5).map((header, index) => (
                        <th
                          key={index}
                          onClick={() => requestSort(index)}
                          style={modalStyles.th}
                        >
                          {header}{" "}
                          {sortConfig.key === index &&
                            (sortConfig.direction === "ascending"
                              ? "↑"
                              : "↓")}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {getFilteredSortedData().map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {row.slice(0, 5).map((cell, cellIndex) => (
                          <td key={cellIndex}>{cell}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="d-flex flex-column justify-content-center px-0">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: "5px",
                    borderTop: "2px solid #ee373b",
                  }}
                >
                  <button
                    type="submit"
                    className="btn btn-outline-danger"
                    style={{
                      width: "150px",
                      height: "40px",
                    }}
                    disabled={!excelFile}
                  >
                    <span className="">Submit</span>
                  </button>
                </div>
              </div>
            </div>
          )}
        </form>
      )}

      {showDuplicatesModal && (
        <div id="duplicates-modal" style={modalStyles.modal}>
          <div
            className="modal-content"
            id="modal-content-radius"
            style={{
              padding: "0px",
              width: "80%",
              maxWidth: "600px",
              borderRadius: "20px",
            }}
          >
            <div className="modal-header" style={modalStyles.modalHeader}>
              <span><BiError size="30" /></span> <p style={modalStyles.headerText}> Duplicate Entries</p>
            </div>
            <div className="p-2" style={modalStyles.customModelBody}>
              <table style={modalStyles.table}>
                <thead style={{ position: "sticky", top: "0" }}>
                  <tr>
                    <th style={modalStyles.th}>Name</th>
                    <th style={modalStyles.th}>Primary Phone</th>
                    <th style={modalStyles.th}>Email</th>
                    <th style={modalStyles.th}>Contact Address</th>
                    <th style={modalStyles.th}>Preapproved Limit</th>
                  </tr>
                </thead>
                <tbody>
                  {duplicates.map((duplicate, index) => (
                    <tr key={index}>
                      <td style={modalStyles.td}>{duplicate.name}</td>
                      <td style={modalStyles.td}>{duplicate.primaryPhone}</td>
                      <td style={modalStyles.td}>{duplicate.email}</td>
                      <td style={modalStyles.td}>{duplicate.contactAddress}</td>
                      <td style={modalStyles.td}>
                        {duplicate.preapprovdlimitvalue}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div
              className="p-2 d-flex justify-content-center"
              style={{
                borderBottomLeftRadius: "20px",
                borderBottomRightRadius: "20px",
              }}
            >
              <button
                className="btn btn-outline-danger"
                onClick={closeDuplicatesModal}
              >
                close
              </button>
            </div>
          </div>
        </div>
      )}

      <InformationModal
        isOpen={isModalOpen}
        onClose={closeInfoModal}
        message={ModalMessage}
      />
    </div>
  );
};

export default LenderUserDataUpload;
